import { render, staticRenderFns } from "./AnimatedWavesBackground.vue?vue&type=template&id=15f0d6d4"
import script from "./AnimatedWavesBackground.vue?vue&type=script&lang=js"
export * from "./AnimatedWavesBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports